
  import { Component, Vue ,Prop, Watch,Inject} from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import UploadImg from '@/components/upload-img.vue';
	import ChoosePages from '@/components/choosepages/choosepages.vue';
  import previewImg from "@/components/previewImg.vue"
  import {
    imgHost
  } from "@/utils/config"
  @Component({  
    name: '',
    components: {
      PageFooter,
      UploadImg,
      ChoosePages,
      previewImg
    }
  })

  export default class ProductList extends Vue {
    // @Prop({default:{}}) msg!:any
    private imglist:any = []
    private mastermap = []
    private token:any = {}
    private defaultimg='/image/1677658403671.png'
    private show = false
    private momentsel = -1
    private moveindex = -1
    private choosemsg:any = {}
    private exampleShow = false
    private currentUrl = 'http://routuan2022.oss-cn-hangzhou.aliyuncs.com/routuan/image/e20a1f21ab0fcd261baa87f4ed15c3c.png'

    @Inject() information:any
    get value(){
      return this.information
    }
    
    @Inject() editinfo:any
    get editmsg(){
      return this.editinfo.msg
    }
    

    private mounted () {

    }

    private cleararea(i){
      //这里要删掉 再重新插入 不然视图更新有问题
      this.editinfo.msg.imglist.splice(i,1,{
        ...this.editinfo.msg.imglist[i],
        marX:0,
        marY:0,
        width:0,
        height:0,
        rgb:'',
      })
      // this.$forceUpdate()
    }
    private startmove(i){
      // console.log(i)
      if(this.editinfo.msg.imglist[i].rgb) return
      this.editinfo.moveindex = i
      this.editinfo.msg.imglist[i] = {
        ...this.editinfo.msg.imglist[i],
        marX:0,
        marY:0,
        width:0,
        height:0,
        rgb:this.rgb()
      }
      this.$forceUpdate()
    }
    private rgb(){
      let r = Math.floor(Math.random()*256)
      let g = Math.floor(Math.random()*256)
      let b= Math.floor(Math.random()*256)
      return `rgb(${r},${g},${b})`
    }
    private del(i){
      this.editinfo.msg.imglist.splice(i,1)
    }
    private clear(i){
      this.moveindex = -1
      this.editinfo.msg.imglist = this.editinfo.msg.imglist.map((v,x)=>{
        if(i==x){
          v.Id = 0
          v.pageurl = ''
          v.PageUrl = ''
          v.PageName = ''
          v.label = ''
          v.pagetype = ''
          v.pagetypelabel = ''
          v.subdivideType = ''
          v.subdivideTypeValue = ''
        }
        return v
      })
    }
    private getdata(e){
      // console.log(e)
      this.show = false
      for(let key in e){
        this.editinfo.msg.imglist[this.momentsel][key] = e[key]
      }
    }
    private push(){
      if(!this.editinfo.msg.img){
        this.$message.error('请先上传图片')
        return 
      }
      this.editinfo.msg.imglist.push({})
    }
    private getImageInfo(url){
      return new Promise((resolve, reject)=>{
        let imageUrl = imgHost + url;
        let image = new Image();
        image.onload = function(){
          resolve({
            width: image.width,
            height: image.height
          });
        }
        image.onerror = function(){
          resolve({
            width: 0,
            height: 0
          });
        }
        image.src = imageUrl;
      })
    }
    private async uploadSuc(list){
      let imageInfo:any = await this.getImageInfo(list[0]);
      this.editinfo.msg.img = list[0]
      this.editinfo.msg.width = imageInfo.width;
      this.editinfo.msg.height = imageInfo.height;
    }
    private emitchange(){
      // let msg = this.msg
      // msg.imglist = this.imglist
      // msg.img = this.mastermap[0]
      // msg.moveindex = this.moveindex
      // // console.log(this.moveindex,'55')
      // // msg.key = Date.now()
      // // console.log(msg,'right')
      // this.$emit('change',msg)
    }
    private choosepage(i){
      this.momentsel = i
      this.choosemsg = this.editinfo.msg.imglist[i]
      this.show = true
    }
  }
